import React from 'react';

/**
 * Native HTML checkbox styled to look good
 * Improved visibility for Android devices with larger size and better visual feedback
 */
export const NativeCheckbox = ({ 
  id, 
  checked = false, 
  onChange, 
  label,
  className = "",
  disabled = false
}) => {
  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <input
        type="checkbox"
        id={id}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        className="w-6 h-6 text-orange-600 bg-white border-2 border-gray-400 rounded focus:ring-orange-500 focus:ring-2 cursor-pointer checked:bg-orange-600 checked:border-orange-600 disabled:opacity-50 disabled:cursor-not-allowed accent-orange-600"
        style={{
          WebkitAppearance: 'checkbox',
          appearance: 'checkbox'
        }}
      />
      {label && (
        <label 
          htmlFor={id} 
          className={`text-sm font-medium leading-none select-none ${
            disabled ? 'cursor-not-allowed opacity-70' : 'cursor-pointer'
          }`}
        >
          {label}
        </label>
      )}
    </div>
  );
};
